module.exports = "<h3>Downloads</h3> <p> Keine Downloads vorhanden. </p> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp-files/modules/app/views/downloads.html
// module id = 346
// module chunks = 0